<template>
  <input
    type="text"
    class="form-control"
    :value="displayValue"
    :placeholder="placeholder"
    :class="{ 'is-invalid': hasError }"
    @input="handleInput"
    @blur="handleBlur"
    @keydown="handleKeydown"
    @paste="handlePaste"
    maxlength="5"
    ref="timeInput"
  />
</template>

<script>
export default {
  name: "TimeInput",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "HH:MM"
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayValue: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.displayValue = this.formatTime(newValue);
      }
    }
  },
  methods: {
    formatTime(value) {
      if (!value) return "";

      const numbers = value.replace(/\D/g, "");

      if (numbers.length === 0) return "";
      if (numbers.length === 1) return numbers;
      if (numbers.length === 2) return numbers;
      if (numbers.length === 3) return numbers;
      if (numbers.length >= 4) {
        return numbers.slice(0, 2) + ":" + numbers.slice(2, 4);
      }

      return value;
    },

    handleInput(event) {
      const input = event.target;
      let value = input.value;

      const numbers = value.replace(/\D/g, "");

      if (numbers.length >= 4) {
        value = numbers.slice(0, 2) + ":" + numbers.slice(2, 4);
      } else {
        value = numbers;
      }

      this.displayValue = value;
      this.$emit("input", value);
    },

    handleKeydown(event) {
      const key = event.key;
      const value = this.displayValue;

      if (
        [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Tab",
          "Enter"
        ].includes(key)
      ) {
        return;
      }

      if (!/^\d$/.test(key)) {
        event.preventDefault();
        return;
      }

      if (value.length >= 5 && key !== "Backspace" && key !== "Delete") {
        event.preventDefault();
        return;
      }
    },

    handleBlur() {
      const value = this.displayValue;
      if (value && value.length === 4 && !value.includes(":")) {
        const formatted = value.slice(0, 2) + ":" + value.slice(2);
        this.displayValue = formatted;
        this.$emit("input", formatted);
      }

      this.$emit("blur");
    },

    handlePaste(event) {
      event.preventDefault();

      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const numbers = pastedText.replace(/\D/g, "");

      if (numbers.length >= 4) {
        const formatted = numbers.slice(0, 2) + ":" + numbers.slice(2, 4);
        this.displayValue = formatted;
        this.$emit("input", formatted);
      } else if (numbers.length > 0) {
        this.displayValue = numbers;
        this.$emit("input", numbers);
      }
    }
  }
};
</script>

<style scoped>
.form-control {
  font-family: monospace;
}
</style>